import { createContext } from "react";
import { type MediaDataRoomVersion } from "features/mediaDataRoom/models";

export interface AudiencesDataPrefetchingContextValue {
  isDataPrefetching: boolean;
  version: MediaDataRoomVersion;
}

export type AudiencesDataPrefetchingAbContextValue =
  AudiencesDataPrefetchingContextValue;
export type AudiencesDataPrefetchingV3ContextValue =
  AudiencesDataPrefetchingContextValue;

export const AudiencesDataPrefetchingContext =
  createContext<AudiencesDataPrefetchingContextValue | null>(null);
AudiencesDataPrefetchingContext.displayName = "AudiencesDataPrefetchingContext";

export interface AudiencesDataPrefetchingContextHook {
  (version?: never): AudiencesDataPrefetchingContextValue;
  (version: MediaDataRoomVersion.v3): AudiencesDataPrefetchingV3ContextValue;
  (version: MediaDataRoomVersion.ab): AudiencesDataPrefetchingV3ContextValue;
}
